import NextImage from 'next/image';

import { Heading } from '../../Heading/Heading';
import { Text } from '../../Text/Text';
import CTABackgroundMobile from '../assets/TopBaitsCTABackground-mobile.png';
import CTABackgroundTablet from '../assets/TopBaitsCTABackground-tablet.png';
import CTABackgroundDesktop from '../assets/TopBaitsCTABackground.png';
import CTABiteGuidePhone from '../assets/TopBaitsCTABiteGuidePhone.png';
import CTABiteGuidePhoneCropped from '../assets/TopBaitsCTABiteGuidePhoneCropped.png';
import { Source } from '../../NextImage/Source';
import { AppStoreButtons } from '../../Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { QRCode } from '../../QRCode/QRCode';
interface IProps {
  sourceId?: string;
  hasTopBaits?: boolean;
}

export const TopBaitsSectionCTA = ({ sourceId, hasTopBaits }: IProps) => {
  return (
    <div className="@container relative">
      {hasTopBaits && (
        <div className="pointer-events-none absolute top-3/5 z-10 size-full bg-[linear-gradient(180deg,#FFF_37.98%,rgba(255,255,255,0)_100%)] sm:bg-[linear-gradient(180deg,#F5F6F7_37.98%,rgba(245,246,247,0)_100%)]"></div>
      )}
      <picture>
        <Source media="(min-width: 990px)" src={CTABackgroundDesktop} />
        <Source media="(min-width: 600px)" src={CTABackgroundTablet} />
        <NextImage
          data-testid="appBannerLogo"
          alt="Fishbrain"
          src={CTABackgroundMobile}
          fill
          className="z-10 rounded-xl shadow-xl"
        />
      </picture>
      <div className="relative z-10 flex flex-row gap-5 p-6 @max-md:flex-col">
        <div className="relative basis-2/3 @md:-mb-6">
          <NextImage
            className="object-cover object-top @max-md:hidden"
            src={CTABiteGuidePhone}
            alt="BiteGuide App feature"
            fill
          />
          <NextImage
            className="@md:hidden"
            src={CTABiteGuidePhoneCropped}
            alt="BiteGuide App feature"
          />
        </div>
        <div className="flex flex-col items-start gap-3 @max-md:items-center @max-md:text-center">
          <div>
            <Heading className="text-sea-foam" variant="xs">
              The right bait right now
            </Heading>
            <Text className="text-sea-foam m-0" variant="sm">
              Find out what lures to use, download the Fishbrain app!
            </Text>
          </div>
          <AppStoreButtons
            className="z-mid md:hidden"
            orientation="vertical"
            source="TopSpeciesCTA"
            sourceId={sourceId}
          />
          <QRCode source="TopSpeciesCTA" className="bg-sea-foam rounded-md p-2" />
        </div>
      </div>
    </div>
  );
};
